import { MaybeExtended, TicketExtended } from "./TypeExtensions";
import { SIGNATURE_ASPECT_RATIO } from "../sharedCode/TripTicketJsonPdf";

export default {};

export interface FormFieldChange {
    updateProperty: string;
    value: MaybeExtended<string> | MaybeExtended<number> | MaybeExtended<boolean>;
}

export interface FormFieldChangeWithPayload {
    updateProperty: string;
    value: MaybeExtended<string> | MaybeExtended<number> | MaybeExtended<boolean>;
    payloadProperty: string;
    payloadValue: any;
}

export enum ErrorLevel {
    Error,
    Warn,
}

export interface ValidationResult {
    entityId: number | string;
    entityName: string;
    propertyName: string;
    editCard: string;
    message: string;
    level: ErrorLevel;
}

export interface CustomControlProps {
    sourceProperty: string;
    initialValue: MaybeExtended<boolean> | MaybeExtended<number> | MaybeExtended<string> | undefined;
    labelText: string;
    isRequired: boolean;
}

export interface RouterCustomControlProps {
    sourceId: number;
    sourceProperty: string;
    labelText: string;
    isRequired: boolean;
    mergeChanges: (targetId: number, changes: Record<string, unknown>) => void;
    isDisabled: boolean;
    errors: ValidationResult[];
    containerUrl: string;
}

export interface BooleanCustomControlProps extends RouterCustomControlProps {
    initialValue: MaybeExtended<boolean> | undefined;
}

export interface YesNoCustomControlProps extends BooleanCustomControlProps {
    onChange: (sourceId: number, value: MaybeExtended<boolean>) => void;
}

export interface IntegerCustomControlProps extends RouterCustomControlProps {
    initialValue: MaybeExtended<number> | undefined;
}

export interface LineItemTypeControlProps extends IntegerCustomControlProps {
    idList: number[];
}

export interface DecimalCustomControlProps extends IntegerCustomControlProps {
    initialValue: MaybeExtended<number> | undefined;
    precision: number;
}

export interface StringCustomControlProps extends RouterCustomControlProps {
    initialValue: MaybeExtended<string> | undefined;
    maxLength?: number;
}

export interface LocationCustomControlProps extends StringCustomControlProps {
    company_id: number;
    ticketList: TicketExtended[];
}

export interface MultilineCustomControlProps extends StringCustomControlProps {
    minRows: number;
}

export interface TimeCustomControlProps extends StringCustomControlProps {
    documentDate: string;
}

export const DEFAULT_SIGNATURE_WIDTH = 550;
export const DEFAULT_SIGNATURE_HEIGHT = DEFAULT_SIGNATURE_WIDTH / SIGNATURE_ASPECT_RATIO;
export const DEFAULT_STROKE_WEIGHT = 2;

export interface SignatureCustomControlProps extends StringCustomControlProps {
    height?: number;
    width?: number;
    strokeWeight?: number;
}

export interface CustomControlWithPayloadProps {
    sourceProperty: string;
    initialValue: MaybeExtended<boolean> | MaybeExtended<number> | undefined;
    labelText: string;
    isRequired: boolean;
    payloadProperty: string;
}

export interface MenuCardContent {
    details: JSX.Element;
    validationMessages: JSX.Element;
}

export interface BackgroundLookup extends BackgroundSync {
    getSelectName(id: number): string;
}

export interface BackgroundProps {
    updateUi: () => void;
}

export interface BackgroundSync {
    hasData: boolean;
    isErrored: boolean;
}

export enum SyncStatus {
    Loading,
    Fresh,
    Stale,
    Error,
}

export interface TableSyncer {
    status: SyncStatus;
    fetchData: (firstRun: boolean) => void;
}
